import * as React from "react";
import {useRef} from "react";
import {TextFieldComponent} from "../common/TextField.component";

export interface IPrimaryDocumentCardProps {
    primaryFile: File | undefined;
    reportName: string;
    submitClicked: boolean;
    onPrimaryFileChosen: (files: FileList | null) => void;
    onReportNameChange: (value: string) => void;
    onRemovePrimaryFile: () => void;
}

export const PrimaryDocumentCard: React.FunctionComponent<IPrimaryDocumentCardProps> = (props) => {
    const primaryFileInputRef = useRef<HTMLInputElement>(null);

    const handleRemove = () => {
        props.onRemovePrimaryFile();
        if (primaryFileInputRef.current) {
            primaryFileInputRef.current.value = "";
        }
    };

    return (
        <div
            className="add-client-report__attachment add-client-report__primary-card"
            data-testid="add-client-report__primary-card"
        >
            <div className="add-client-report__inputs">
                <h4 className="add-client-report__attachment-header">
                    Primary document <span className="add-client-report__required-label">(required)</span>
                </h4>
                <a
                    role="link"
                    className="add-client-report__remove-file clickable"
                    data-testid="add-client-report__remove-primary-file"
                    onClick={handleRemove}
                >
                    Remove file
                </a>
            </div>

            <div className="add-client-report__inputs">
                <div className="add-client-report__upload-file">
                    <label htmlFor="primary-file-input" className="add-client-report__label-file">
                        File
                    </label>
                    <input
                        ref={primaryFileInputRef}
                        id="primary-file-input"
                        data-testid="primary-file-input"
                        className="add-client-report__file-input"
                        type="file"
                        accept=".pdf,.ppt,.pptx"
                        onChange={(e) => props.onPrimaryFileChosen(e.target.files)}
                    />
                    <div className="add-client-report__file-hint">PDF · PPT · PPTX · max 50 MB</div>
                </div>

                <div className="add-client-report__input-container">
                    <div className="add-client-report__label">Report Name</div>
                    <TextFieldComponent
                        name="report-name"
                        className="add-client-report__report-name-input"
                        type="text"
                        fullWidth={true}
                        value={props.reportName}
                        handleChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            props.onReportNameChange(e.target.value);
                        }}
                        placeholder={props.primaryFile ? "Report Name" : "Choose a file first"}
                        renderRequired={false}
                        submitClicked={props.submitClicked}
                    />
                </div>
            </div>
        </div>
    );
};